import React, { Component } from 'react';

// Image Imports
import createAccountMobileImg from 'images/create-account-mobile.jpg';
import createAccountDesktopImg from 'images/create-account-desktop.jpg';
import createAccountAfterImg from 'images/create-account-after.jpg';
import documentUpload2 from 'images/document-upload-2.jpg';
import documentUpload from 'images/document-upload.jpg';
import documentUpload3 from 'images/document-upload-3.jpg';
import findApplicationDesktop from 'images/find-application-desktop.jpg';
import findApplicationMobile from 'images/find-application-mobile.jpg';
import forgotUsername from 'images/forgot-username.jpg';
import forgotPassword from 'images/forgotpassword.jpg';
import loginBox from 'images/loginbox.jpg';
import plpDontKnowDesktop from 'images/plp-dont-know-desktop.jpg';
import plpDontKnowMobile from 'images/plp-dont-know-mobile.jpg';
import plpExistingAccountLoginDesktop from 'images/plp-existing-account-login-desktop.jpg';
import plpExistingAccountLoginMobile from 'images/plp-existing-account-login-mobile.jpg';
import renewalRenewNowDesktop from 'images/renewal-renew-now-desktop.jpg';
import renewalRenewNowMobile from 'images/renewal-renew-now-mobile.jpg';

export default class FaqList extends Component {
  render() {
    return (
      <React.Fragment>
        <div class="usa-section">
          <div class="grid-container">
            <div class="grid-row grid-gap">
              <div class="usa-layout-docs__sidenav desktop:grid-col-3">
                <nav aria-label="Secondary navigation">
                  <ul class="usa-sidenav">
                    <li class="usa-sidenav__item">
                      <a href="#user-account-creation" class="navigation-highlight">User Account Creation</a>
                    </li>
                    <li class="usa-sidenav__item">
                      <a href="#logging-into-an-existing-account" class="navigation-highlight">Logging In To An Existing Account</a>
                      <ul class="usa-sidenav__sublist">
                        <li class="usa-sidenav__item">
                          <a href="#how-do-i-log-into-my-account-profile">How do I log into my account / profile?</a>
                          <ul class="usa-sidenav__sublist">
                            <li class="usa-sidenav__item">
                              <a href="#do-you-know-your-username">Do you know your username?</a>
                            </li>
                            <li class="usa-sidenav__item">
                              <a href="#i-cant-remember-my-password">I can't remember my password</a>
                            </li>
                            <li class="usa-sidenav__item">
                              <a href="#my-account-is-locked">My account is locked</a>
                            </li>
                            <li class="usa-sidenav__item">
                              <a href="#i-cannot-reset-my-password">I cannot reset my password</a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li class="usa-sidenav__item">
                      <a href="#applying-for-a-license" class="navigation-highlight">Originating or Renewing a License</a>
                    </li>
                    <li class="usa-sidenav__item">
                      <ul class="usa-sidenav__sublist">
                        <li class="usa-sidenav__item">
                          <a href="#how-do-i-find-the-application">How Do I Find the Application?</a>
                        </li>
                        <li class="usa-sidenav__item">
                          <a href="#issues-filling-out-my-application">I can't start an application to originate my license</a>
                        </li>
                        <li class="usa-sidenav__item">
                          <a href="#i-cant-find-my-issued">I can't find my issued license or application submission</a>
                        </li>
                        <li class="usa-sidenav__item">
                          <a href="#renew-my-license">I'm trying to renew my License</a>
                          <ul class="usa-sidenav__sublist">
                            <li class="usa-sidenav__item">
                              <a href="#how-to-renew">How to renew your existing license</a>
                            </li>
                            <li class="usa-sidenav__item">
                              <a href="#why-cant-i-renew">Why can't I renew my License?</a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li class="usa-sidenav__item">
                      <a href="#application-troubleshooting" class="navigation-highlight">Application Submission Troubleshooting</a>
                      <ul class="usa-sidenav__sublist">
                        <li class="usa-sidenav__item">
                          <a href="#how-do-i-upload-a-document">How do I Upload a Document?</a>
                        </li>
                        <li class="usa-sidenav__item">
                          <a href="#what-is-the-status">What is the status of my application submission or license?</a>
                        </li>
                      </ul>
                    </li>
                    <li class="usa-sidenav__item">
                      <a href="#support-contacts" class="navigation-highlight">Agency Operation Questions</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <main class="usa-layout-docs__main desktop:grid-col-9 usa-prose usa-layout-docs" id="main-content">
                <h1>RLP Help</h1>
                <h2 id="section-heading-h2">User Account Creation</h2>
                <ul>
                  <li>How do I create a new account?
                    <ol type="a">
                      <li>Navigate to the portal URL</li>
                      <li>
                        Select the screen option "Create Account"
                        <div class="help-image-desktop">
                          <img src={createAccountDesktopImg} alt="PLP page create account highlighted" />
                        </div>
                        <div class="help-image-mobile">
                          <img src={createAccountMobileImg} alt="PLP page create account highlighted" />
                        </div>
                      </li>
                      <li>
                        The Create Account screen appears
                        <img src={createAccountAfterImg} alt="Create Account page showing form fields" />
                      </li>
                      <li>The Account Type is very important and cannot be changed once the new user account is created.
                        <ol type="i">
                          <li>Account Types:
                            <ol type="1">
                              <li>Personal account type is for licenses associated to an individual </li>
                              <li>Business account type is for businesses</li>
                              <li><strong>NOTE:</strong> If you arrive at this screen as part of trying to start an application, the Account Type will be locked to the correct value for the application that you were accessing.</li>
                            </ol>
                          </li>
                        </ol>
                      </li>
                      <li>
                        An email will be sent to the email associated to the Username. The email will have a link to create the password and complete the account profile.
                        <ol type="i">
                          <li><strong>NOTE:</strong> Email will be from: noreply@lnpweb.com</li>
                          <li><strong>NOTE:</strong> Check your SPAM folder if the email does not appear in the Inbox.</li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                </ul>
                <h2 id="logging-into-an-existing-account">Logging In To An Existing Account</h2>
                <h3 id="how-do-i-log-into-my-account-profile">How do I log into my account / profile?</h3>
                <ul>
                  <li>Navigate to the your portal URL</li>
                </ul>
                <h3 id="do-you-know-your-username">Do you know your username?</h3>
                <ul>
                  <li><u><strong>Yes</strong></u>. Select the screen option “Login" </li>
                  <ul>
                    <li style={{ listStyleType: 'none' }}>
                      <div class="help-image-desktop">
                        <img src={plpExistingAccountLoginDesktop} alt="PLP page know my username highlighted" />
                      </div>
                      <div class="help-image-mobile">
                        <img src={plpExistingAccountLoginMobile} alt="PLP page know my username highlighted" />
                      </div>
                    </li>
                    <li>The Login screen appears</li>
                    <li style={{ listStyleType: 'none' }}><img src={loginBox} alt="login screen with username and password" /></li>
                    <li>{"Enter your Username & Password"}</li>
                    <li><strong>NOTE:</strong>{" Both the username & password are case sensitive."}</li>
                    <li>Did you forget your password? Visit, <a href="#i-cant-remember-my-password">I can't remember my password.</a></li>
                  </ul>
                </ul>
                <ul>
                  <li><u><strong>No</strong></u>. Select the screen option “Existing account login – I don’t know my username”</li>
                  <ul>
                    <li style={{ listStyleType: 'none' }}>
                      <div class="help-image-desktop">
                        <img src={plpDontKnowDesktop} alt="PLP page don't know my username highlighted" />
                      </div>
                      <div class="help-image-mobile">
                        <img src={plpDontKnowMobile} alt="PLP page don't know my username highlighted" />
                      </div>
                    </li>
                    <li>The Forgot Username screen appears. Enter the email associated with your account.</li>
                    <li style={{ listStyleType: 'none' }}><img src={forgotUsername} alt="forgot username screen" /></li>
                    <li>An email will be sent to the email entered. It is possible to have multiple user accounts/profiles. All Usernames associated to the email address entered will be listed on the email notification.
                      <ol type="i">
                        <li><strong>NOTE:</strong> Email will be from: noreply@lnpweb.com</li>
                        <li><strong>NOTE:</strong> If you have multiple email addresses, be sure to use the email address associated to the user account/profile.</li>
                        <li><strong>NOTE:</strong> Check your SPAM folder if the email does not appear in the Inbox.</li>
                      </ol>
                    </li>
                  </ul>
                </ul>
                <h3 id="i-cant-remember-my-password">I can't remember my password</h3>
                <ul>
                  <li>Use the forgot password feature. First, navigate to your portal.</li>
                  <li>Select the button for “Login”</li>
                  <li style={{ listStyleType: 'none' }}>
                    <div class="help-image-desktop">
                      <img src={plpExistingAccountLoginDesktop} alt="PLP page know my username highlighted" />
                    </div>
                    <div class="help-image-mobile">
                      <img src={plpExistingAccountLoginMobile} alt="PLP page know my username highlighted" />
                    </div>
                  </li>
                  <li>Login screen appears</li>
                  <li style={{ listStyleType: 'none' }}><img src={loginBox} alt="login screen with username and password" /></li>
                  <li>Click "Forgot your password?"</li>
                  <li style={{ listStyleType: 'none' }}><img src={forgotPassword} alt="forgot password screen with username input" /></li>
                  <li><strong>NOTE:</strong> Username is case sensitive. If you don’t know your username, you’ll need to recover your username first. <a href="#do-you-know-your-username">Click here.</a>
                    <ol type="i">
                      <li><strong>NOTE:</strong> Email will be from: noreply@lnpweb.com</li>
                      <li><strong>NOTE:</strong> If you have multiple email addresses, be sure to use the email address associated to the user account/profile.</li>
                      <li><strong>NOTE:</strong> Check your SPAM folder if the email does not appear in the Inbox.</li>
                    </ol>
                  </li>
                </ul>
                <h3 id="my-account-is-locked">My account is locked</h3>
                <ul>
                  <li>User accounts auto unlock within an hour.</li>
                </ul>
                <h3 id="i-cannot-reset-my-password">I cannot reset my password</h3>
                <ul>
                  <li>User account may not have been activated.</li>
                  <li>Please contact your administrator for assistance.</li>
                </ul>
                <h2 id="applying-for-a-license">Applying for a License (Original or Renewal)</h2>
                <h3 id="how-do-i-find-the-application">How Do I Find the Application?</h3>
                <p>All the currently available applications are listed in the Find Application table. The Find My Application search box allows you to search for an application by using all the data in the table. Simply type in the agency name, application
                  name, or phrases commonly related to the license type and select the search button. The table will be filtered down to results matching your search.</p>
                <div class="help-image-desktop">
                  <img src={findApplicationDesktop} alt="Find application section with Find My Application input highlighted" />
                </div>
                <div class="help-image-mobile">
                  <img src={findApplicationMobile} alt="Find application section with Find My Application input highlighted" />
                </div>
                <h2 id="issues-filling-out-my-application">Issues filling out my application</h2>
                <h3 id="im-getting-an-error">I’m getting an error when I try to open my application.</h3>
                <p>Most applications to originate licenses can only be submitted by an applicant when:</p>
                <ul>
                  <li>You do not already have a pending submission of the same application</li>
                  <li>You do not already hold the license</li>
                  <li>If you are ineligible, the system displays: "Our records indicate you are not eligible to apply for a "License Type Display Name" license/permit because one is already issued or active on your account. If you have any questions,
                    please contact your agency at "AgencyContactEmail" or "AgencyContactNumber". Click here to go to your account."</li>
                </ul>
                <h3 id="i-cant-find-my-issued">I can’t find my issued license or application submission.</h3>
                <p>Were you able to login and view your profile?</p>
                <ul>
                  <li>
                    <u><strong>Yes</strong></u>
                    <ol type="a">
                      <li>Navigate to the Certificate/License tab to view License(s).</li>
                      <li>Navigate to the Submission tab to view applications that you have submitted to the agency. Note the status of the submitted applications
                        <ol type="i">
                          <li>Approved means a License has been granted by the agency.</li>
                          <li>Denied means a License has not been granted by the agency and no further action is possible.</li>
                          <li>Pending means the submission is currently under review by the agency.</li>
                          <li>Rejected means the agency has requested corrections to a prior submission before it can complete its review. Use the controls on the draft submission created from the rejected submission to take further action.</li>
                        </ol>
                      </li>
                      <li>If both tabs do not list any line items for the license in question and you received email notifications regarding submitting an application or approval of the application, you may not be logged in to the correct account.
                        Try <a href="#do-you-know-your-username">Existing account login – I don’t know my username</a> to validate if the email address is associated to multiple user accounts.
                        <ol type="i">
                          <li>
                            If you still cannot find what you are looking for, please contact your administrator.
                    
                          </li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                </ul>
                <ul>
                  <li><u><strong>No</strong></u> refer to the <a href="#logging-into-an-existing-account">Logging In To An Existing Account</a> section for help</li>
                </ul>
                <h2 id="how-to-renew">I'm trying to renew my license</h2>
                <h3>How to renew your existing license.</h3>
                <p>There are two ways to renew you license in RLP. You may only renew your license during the renewal window, which is the period of time before and after your license expires during which you are allowed to renew.</p>
                <ol>
                  <li>
                    Directly from a renewal reminder email link. Clicking the link will prompt you to login to your account and then take you directly to the application for most licenses. If the license type allows you to hold more than one license
                    concurrently, logging in will take you to a listing of your licenses and you will need to follow the instructions in #2.
                    <ol type="a">
                      <li><strong>NOTE:</strong> The email subject lines associated with renewing are:
                        <ol type="i">
                          <li>&#60;agencyShortName&#62;-&#60;LicenseDisplayName&#62; Renewal Period Notification. This email is sent when the renewal window opens and prior to license expiration.</li>
                          <li>&#60;agencyShortName&#62;-&#60;LicenseDisplayName&#62; Expiration Notification – Renewal Window Open. This email is sent when the license has expired but the renewal window is still open. A late fee may be charged to
                            renew. Whether a late is charged and the amount of the late fee are dependent on rules that vary by license type.</li>
                          <li>&#60;agencyShortName&#62;-&#60;LicenseDisplayName&#62; Renewal Period Closed. This email is sent when the license has expired and the renewal window is closed. It is no longer possible to renew the license yourself. The
                            agency may still be able to renew the license for you. Whether they can renew for you is depending on rules that vary by license type. Contact the agency at the support information listed in the email.</li>
                        </ol>
                      </li>
                      <li>
                        <strong>NOTE:</strong> If you have received an email reminding you to renew, you already have an account. Do not create a new account to renew your license. Login with your Username & Password associated to the License. If you
                        have received the
                        email with the subject of “&#60;agencyShortName&#62;-&#60;LicenseDisplayName&#62; Renewal Period Closed,” you can no longer renew. Please contact the Agency for next steps.
                      </li>
                    </ol>
                  </li>
                  <li>
                    From within the Certificate/License/Permit tab of your account. On this tab, select the “Renew Now” link for the license that you want to renew.
                    <ol type="a">
                      <li><strong>NOTE:</strong> Make sure your pop-up blocker is off or does not block the site.</li>
                      <li><strong>NOTE:</strong> Chrome is the ideal browser for renewing a license. </li>
                      <li><strong>NOTE:</strong> Internet Explorer 11 is supported but not recommended.</li>
                    </ol>
                  </li>
                </ol>
                <div class="help-image-desktop">
                  <img src={renewalRenewNowDesktop} alt="Renewal table, Renew Now example screenshot" />
                </div>
                <div class="help-image-mobile">
                  <img src={renewalRenewNowMobile} alt="Renewal table, Renew Now example screenshot" />
                </div>
                <h3 id="why-cant-i-renew">Why can't I renew my License?</h3>
                <p>The are several reasons why you may not be able to renew your license.</p>
                <ul>
                  <li>If you attempt to start a renewal application from an account that does not hold the license, you will receive the error message, “Not allowed. An original license/permit must exist before submitting a renewal application. Click
                    here to go to your profile.” You will need to login to the account that holds the license (<a href="#user-account-creation">go here for help finding your existing account</a>) or submit the application to apply for the original
                    license instead of the renewal
                    application.</li>
                  <li>If you are logged into an account that holds a license, you may still be unable to start/continue a renewal application. Renewal applications to renew licenses can only be submitted by a Licensee when:
                    <ol type="a">
                      <li>The license is in a status that allows renewals (typically Issued, Active, Expired, or Suspended)</li>
                      <li>You are applying within the renewal window. The renewal window is the period of time before and after you license expires during which you are allowed to renew.</li>
                      <li>You do not already have a pending renewal submission</li>
                      <li>You do not already have an issued/approved renewal submission that would result in overlapping license validity periods with the new renewal submission</li>
                      <li>The submission would not violate other business rules that are specific to a license type, e.g. the DHHC has a Provisional license that can only be renewed once</li>
                      <li><strong>NOTE:</strong> If you are ineligible, the system displays: "Our records indicate you are not eligible to submit a &#60;License Type Display Name&#62; renewal application at this time. This could be because you have
                        submitted a renewal application already or your license is in a non-eligible status. If you have any questions, please contact your agency at &#60;AgencyContactEmail&#62; or &#60;AgencyContactNumber&#62;. Click here to go to
                        your account."</li>
                    </ol>
                  </li>
           
                </ul>
                <h2 id="application-troubleshooting">Application Troubleshooting</h2>
                <h3 id="how-do-i-upload-a-document">How Do I Upload a Document</h3>
                <ul>
                  <li>Document Requirements are: <strong>File size and type limitations per attachment: 10 MB for csv, doc, docx, jpg, jpeg, png, pdf, txt, xls, xlsx</strong>.</li>
                  <li>Click the “Upload” button to find the desired document.</li>
                </ul>
                <img src={documentUpload} alt="document upload screen with highlighted upload" />
                <p>Select a file using your operating system’s dialog. The document is populated in the filename field.</p>
                <img src={documentUpload2} alt="second document upload screen with highlighted save and close" />
                <p>Click “Save” once the document to upload has been selected and is visible. A “Please Wait” spinner is shown while the document is uploaded and scanned for viruses. You may also cancel if you want to select a different file. After
                  canceling, the Upload button returns. Assuming you saved, the document now appears with a Delete button. No further action is necessary if you wish to include this document on the application.</p>
                <img src={documentUpload3} alt="third document upload screen with highlighted delete" />
                <h3 id="what-is-the-status">What is the status of my submission?</h3>
                <p>RLP sends you an email every time the status of your application submission and license changes. The email is from noreply@lnpweb.com. For further information on finding your submission or your license within your account, go to <a
                    href="#i-cant-find-my-issued">I can’t find my issued license or application submission</a>.</p>

              </main>
            </div>
          </div>
        </div>
        <div class="grid-container usa-footer__return-to-top">
          <a href="#" onClick={() => window.scrollTo(0,0)}>Return to top</a>
        </div>
      </React.Fragment>
  )}
}



// WEBPACK FOOTER //
// ./src/features/faq/FaqList.js